export const registeredLuggageProductCodes = ['EXCLUG_LUG', 'OVERSIZE_LUG', 'BIKEBOX_LUG', 'BIKEASSEMBLED_LUG', 'MUSIC_LUG', 'SPORT_LUG'];

export const LUGGAGE_STORAGE_CUTOFF_MINUTES = 10;
